import { Injectable } from '@angular/core';
import { User } from '../../../models/User';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../../services/user.service';
import {tap} from "rxjs/operators";

@Injectable()
export class AuditTrailsUsersResolver implements Resolve<Array<User>> {

    resolve(): Observable<Array<User>> {
        return this.userService.fetchAllUsers(null, true).pipe(
            tap((users: Array<User>) => {
                this.userService._customerUsers$.next(users);
            })
        );
    }

    constructor(private userService: UserService) { }
}
